import { CreateContract } from 'features/SubmitProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';
import { Can } from 'components/Can';

function DetailContractPage() {
  return (
    <LayoutProvider>
      <Layout>
        <Can do="create" on="project">
          <CreateContract disabled />
        </Can>
      </Layout>
    </LayoutProvider>
  );
}

export default DetailContractPage;
